export default function preloaderCredits (scene) {
    scene.load.image(`background-buttons-win`, `/img/generalSprites/background_buttons_win.png`);
    scene.load.image(`button1-win`, `/img/generalSprites/button_win_home.png`);
    scene.load.image(`button2-win`, `/img/generalSprites/button_special_video_win.png`);

}